import Main from "./page";
export { Main };
import Registration from "./reg";
export { Registration };
import Profile from "./profile";
export { Profile };

import Router from "./router";
export default Router;
